import './bootstrap';

import Vue from 'vue';

import App from "./App.vue";

Vue.config.devtools = true;
Vue.config.debug = true;

import VueRouter from 'vue-router';
Vue.use(VueRouter);

import CookiesBanner from './components/CookiesBanner';
Vue.component('cookies-banner', CookiesBanner);

import SpotifyFooter from './components/SpotifyFooter';
Vue.component('spotify-footer', SpotifyFooter);

import FadeImg from './components/FadeImg';
Vue.component('fade-img', FadeImg);

import VueYouTubeEmbed from 'vue-youtube-embed';
Vue.use(VueYouTubeEmbed);

import Flickity from 'vue-flickity';
// Fix sliders breaking on router view change
Flickity.beforeDestroy = undefined;
Vue.component('flickity', Flickity);

import VueScrollTo from 'vue-scrollto';
Vue.use(VueScrollTo);

import Multiselect from 'vue-multiselect';
Vue.component('multiselect', Multiselect);

import router from './router';

import 'animate.css/animate.min.css';

import 'vue-multiselect/dist/vue-multiselect.min.css';

import isMobile from './mixins/isMobile.js';

import SpotifyLogin from './mixins/SpotifyLogin.js';

import { googleAnalyticsTrackingIDs } from './constants.js';

import VueAnalytics from 'vue-analytics';
Vue.use(VueAnalytics, {
	id: googleAnalyticsTrackingIDs,
	router,
	autoTracking: {
		exception: true
	},
	debug: {
		enabled: false,
		trace: false,
		sendHitTask: false
	}
});

Vue.mixin({
	methods: {
		gaEvent(pageName, action, label) {
			this.$ga.event(pageName, action, label);
		}
	},
});

new Vue({
	mixins: [isMobile, SpotifyLogin],
	router,
	// store,
	render: h => h(App),
}).$mount("#app");